import { HeaderComponent } from "@/components/headerComponet";
import { Toolbar, Typography } from "@mui/material";
import { ActiveItemProvider } from "../home/context/ActiveItemContext";
import DrawerComponent from "@/components/DrawerComponent";
import { TabelaFeedback } from "./componentes/tabelaFeedback";
import styles from "./style.module.css";
import { Abas } from "./componentes/abas";

export function NetPromoterScore(){
  return(
    <>
      <div>
        <HeaderComponent />
        <Toolbar />
        <ActiveItemProvider>
          <DrawerComponent />
        </ActiveItemProvider>
      </div>

      <div className={styles.nps_container}>
        <Typography 
          variant="h5" 
          color={"#4c4e64c8"} 
          fontWeight={"bold"}
        >
          Listagem de Feedback
        </Typography>

        <div className={styles.table_container}>
          <Abas/>
          <TabelaFeedback/>
        </div>
      </div>
    </>
  )
}